import { useMutation } from '@tanstack/react-query';

import { getAuditOrder } from '../../../../api';

export const useOrderAudit = () =>
  useMutation({
    mutationKey: ['getAuditOrder'],
    mutationFn: (data: Record<string, string | null>) => getAuditOrder(data),
  });
